import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const Bareksa = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.7275 0L13.5112 3.78312C14.4595 4.73278 14.4595 6.27097 13.5112 7.22062L10.7 10.03L10.7006 19.9725H8.755L8.754 10.03L5.94438 7.22062C5.03924 6.31414 4.9981 4.8714 5.82095 3.91616L5.94438 3.78312L9.7275 0ZM5.35 9.2725C5.99546 9.2725 6.61446 9.52904 7.0707 9.98563C7.52694 10.4422 7.783 11.0614 7.7825 11.7069V17.0569H2.43188C1.08879 17.0569 0 15.9681 0 14.625V9.2725H5.35ZM14.105 9.2725L19.4556 9.275V14.625C19.4542 15.9671 18.3659 17.0544 17.0238 17.0544H11.6731V11.7044C11.6731 10.3613 12.7619 9.2725 14.105 9.2725ZM4.86375 11.2181H1.94563V14.1362C1.94563 14.6733 2.38103 15.1087 2.91813 15.1087H5.83687V12.1906C5.83653 11.6534 5.40095 11.2181 4.86375 11.2181ZM17.51 11.2181H14.5919C14.0547 11.2181 13.6191 11.6534 13.6187 12.1906V15.1087H16.5375C17.0746 15.1087 17.51 14.6733 17.51 14.1362V11.2181ZM9.72688 2.75313L7.66438 4.81563C7.28481 5.19537 7.28481 5.81088 7.66438 6.19063L9.72688 8.25313L11.7894 6.19063C12.1689 5.81088 12.1689 5.19537 11.7894 4.81563L9.72688 2.75313Z"
      fill="currentColor"
    />
  </svg>
)

export default Bareksa
